/** Status nikad nije samo boja: uz njega ide oznaka i oblik (DR-4A).
 *  Glifovi su inline SVG, jer se glifovima iz pisma ne vjeruje kroz preglednike. */
export type Oblik = 'krug' | 'crta' | 'sestougao' | 'trougao' | 'romb' | 'prsten'

export function Glif({ oblik }: { oblik: Oblik }) {
  const zajednicko = { width: 12, height: 12, viewBox: '0 0 12 12', 'aria-hidden': true } as const
  switch (oblik) {
    case 'krug':
      return (
        <svg {...zajednicko}>
          <circle cx="6" cy="6" r="5" fill="currentColor" />
        </svg>
      )
    case 'prsten':
      return (
        <svg {...zajednicko}>
          <circle cx="6" cy="6" r="4.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      )
    case 'crta':
      return (
        <svg {...zajednicko}>
          <rect x="1" y="5" width="10" height="2" fill="currentColor" />
        </svg>
      )
    case 'trougao':
      return (
        <svg {...zajednicko}>
          <path d="M6 1 L11.5 11 L0.5 11 Z" fill="currentColor" />
        </svg>
      )
    case 'romb':
      return (
        <svg {...zajednicko}>
          <path d="M6 0.5 L11.5 6 L6 11.5 L0.5 6 Z" fill="currentColor" />
        </svg>
      )
    case 'sestougao':
      return (
        <svg {...zajednicko}>
          <path d="M3.5 1 H8.5 L11 6 L8.5 11 H3.5 L1 6 Z" fill="currentColor" />
        </svg>
      )
  }
}
